<template> 
  <div class='px-3 py-3 mb-5 col-24 col-md-11'>
    <div class='col d-column'>
      <h1 class="title pt-2 mb-0">Tags</h1>
      <h1 class="title"><span class="pb-2"> {{ $ml.get('tagsAreUsedToHelpIdentifyReports')}} </span></h1>  
 
      <div class='card mb-3'>
        <div class='card-header'>
          <h6 class='m-0 p-0 light'> {{ $ml.get('tagsForReports') }} </h6>
        </div> 
        <div class='card-body p-0'>
          <h6 class="m-3 pb-2">
            {{ $ml.get('registerBelowTheTags') }} 
          </h6>
         
          <div class="m-3"> 
            <b-form-tags
            class="inputTags mt-3 py-3"
            input-id="tags-pills"
            v-model="optionsTags"
            tag-variant="primary"
            tag-pills
            size="md"
            separator=","
            :placeholder="$ml.get('enterNewTags')"
            addButtonText=""
            variant="primary"
            :limit="30"
            :limit-tags-text="$ml.get('itIsNotPossibleToEnterMore')"
            ></b-form-tags> 
          </div> 
          
          <div class="row m-3"> 
            <button  class="btn btnForm" @click="alterTag" >
              <Spinner v-show="loadingBtn" />
              <span v-show="!loadingBtn" v-text="$ml.get('update')" ></span >
            </button>

            <button class="btn btn-outline-extra m-0 ml-2" @click="changeTags"> 
              <span v-text="$ml.get('cancel')"></span>
            </button> 
          </div>
            
        </div> 
      </div> 
    </div> 
  </div> 
</template>

<script>
import CompanyService from "../../services/company.service";
import Swal from "sweetalert2";
import { utils } from "../../utils";

const regexOTN = utils.regexCheck("OTN");

export default { 
  data() {
    return {
      optionsTags: [],
      loadingBtn: false,  
    };
  },
  mounted() { 
    this.changeTags(); 
  },
  methods: {

    changeTags() {
      this.optionsTags = []
      CompanyService.getTags().then(
        (response) => { 
          this.loadingBtn = false;
          this.optionsTags = response.data?.settings?.report_tags;
        },
        () => { 
          this.loading = false;
        }
      );
    },

    alterTag() {

      let verifyregex = false;
      var self = this;
 
      this.optionsTags.forEach(element => {
  
        if( !regexOTN(element) ){
          verifyregex = true;
        }
        
      });

      if(verifyregex){
        Swal.fire({
          icon: "info",
          html: `<h4>${self.$ml.get("cannotEnterSpecialCharacters")}</h4`,
          showConfirmButton: false,
          timer: 10000,
        });
        return;
      }
 
      this.loadingBtn = true;
      
      CompanyService.putTags({
        tags: this.optionsTags })
        .then(() => {  
          this.changeTags();
          this.loadingBtn = false;
      }) 
      .catch (() => {
        
        this.loadingBtn = false 
        Swal.fire({
          icon: "info",
          html: `<h4>${self.$ml.get("unableToCompleteThisRequest")}</h4`,
          showConfirmButton: false,
          timer: 10000,
        });
      })
  
    },
  },
};
</script>
<style lang="scss">
.inputTags {
  box-shadow: none !important;
  background-color: white; 
  input {
    background: rgb(255, 255, 255);
    border-radius: 0;
    box-shadow: none !important;  
  }
  .badge-primary {
    color: #730ca8;
    background-color: #fefdff;
    padding: 5px 9px 6px 9px;
    font-size: 13px;
    font-weight: 500; 
    border: 2px solid #730ca8;  
    margin-right: 10px;
    margin-top: 10px;
  }
  .btn {
    display: none; 
  }
}
</style>
 